//import lottie from 'lottie-web'


// for using add class lazy to img, div or iframe and add data-img-src/medium/large attributes with urls

let imgSize = 'data-img-src'
if (window.innerWidth <= 600) {
  imgSize = 'data-img-phone'
} else if (window.innerWidth <= 1000) {
  imgSize = 'data-img-tablet'
} else if (window.innerWidth > 2000) {
  imgSize = 'data-img-x2'
}
let last_scroll_top = $(window).scrollTop() - 1

// global function for using in popups or after ajax
function loadElementLazyImage(elements) {
  elements.each(function () {
    let elem = $(this)
    let imgSrc = elem.attr(imgSize)

    let nodname = elem[0]['nodeName']
    let position = elem.data('img-position')
    if (!imgSrc) { imgSrc = elem.attr('data-img-src') }
    if (!position) position = 'center'

    if (nodname !== 'IMG' && nodname !== 'IFRAME' && nodname !== 'VIDEO') {
      elem.css('background', 'url(' + imgSrc + ') no-repeat ' + position)
      elem.css('background-size', 'cover')
    } else {
      if (nodname === 'VIDEO'){
        elem.find('source').attr('src', imgSrc)
        this.load()
      } else {
        elem.attr('src', imgSrc)
      }
    }
  })
}


// check if in screeen
function isScrolledIntoView(elem, offset) {
  let docViewTop = $(window).scrollTop()
  let docViewBottom = docViewTop + $(window).height()
  let elemTop = elem.offset().top - offset
  let elemBottom = elemTop + elem.outerHeight() + (offset * 2)
  if (last_scroll_top < docViewTop) {
    return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom))
  } else {
    return ((elemBottom >= docViewTop) && (elemTop <= docViewTop))
  }
}

// add element class when scrolled in screen
function addClassWhenInScreen(elem, addClass) {
  let animateOffset = window.innerWidth >= 1000 ? -100 : 0;
  if (isScrolledIntoView(elem, animateOffset) && elem.offsetParent !== null) {
    elem.addClass(addClass)
  }
}


function loadLazyImages () {
  $('.lazy').each(function (i, l) {
    if (isScrolledIntoView($(this), 300) && this.offsetParent !== null && !$(this).hasClass('load-later')) {
      loadElementLazyImage($(this))
    }
  })

}


// activate on
$(window).scroll(function () {
  loadLazyImages()
  last_scroll_top = $(window).scrollTop()
})
$(window).resize(function () { loadLazyImages() })
loadLazyImages()

$(window).on('load', function (){
  loadLazyImages()
})

export { loadElementLazyImage, isScrolledIntoView }
